const jhssocialStudiesQuestions = [
   
{
  question: "Which of the following best explains why Accra is the capital city of Ghana?",
  options: [
    "It has the highest population",
    "It is the seat of government administration",
    "It produces the most food",
    "It is centrally located"
  ],
  answer: "It is the seat of government administration"
},
{
  question: "A citizen who refuses to vote during elections is neglecting which civic duty?",
  options: [
    "Paying taxes",
    "Promoting democracy",
    "Obeying laws",
    "Protecting the environment"
  ],
  answer: "Promoting democracy"
},
{
  question: "Why is a chief important in settling disputes in traditional communities?",
  options: [
    "He enforces modern laws",
    "He represents cultural authority and traditions",
    "He works for the police",
    "He controls elections"
  ],
  answer: "He represents cultural authority and traditions"
},
{
  question: "What is the importance of the Equator in geography?",
  options: [
    "It divides the Earth into two equal halves",
    "It shows direction of winds",
    "It separates continents",
    "It marks cold regions"
  ],
  answer: "It divides the Earth into two equal halves"
},
{
  question: "Which institution is mainly responsible for maintaining law and order in Ghana?",
  options: [
    "Judiciary",
    "Ghana Police Service",
    "Electoral Commission",
    "Parliament"
  ],
  answer: "Ghana Police Service"
},
{
  question: "Which action best promotes unity in a country with many ethnic groups?",
  options: [
    "Encouraging tribalism",
    "Promoting religious tolerance",
    "Ignoring minority groups",
    "Separating communities"
  ],
  answer: "Promoting religious tolerance"
},
{
  question: "Child labour is harmful mainly because it:",
  options: [
    "Provides income for families",
    "Prevents children from accessing education and rights",
    "Encourages responsibility",
    "Reduces poverty quickly"
  ],
  answer: "Prevents children from accessing education and rights"
},
{
  question: "Which of the following correctly distinguishes physical features from human features?",
  options: [
    "Physical features are natural while human features are man-made",
    "Human features are natural",
    "Physical features are created by people",
    "Both are artificial"
  ],
  answer: "Physical features are natural while human features are man-made"
},
{
  question: "Why is population census important to national development?",
  options: [
    "To increase population size",
    "To plan and allocate resources effectively",
    "To control elections",
    "To reduce unemployment"
  ],
  answer: "To plan and allocate resources effectively"
},
{
  question: "Teenage pregnancy affects society mainly by:",
  options: [
    "Increasing employment",
    "Causing school dropout and limiting opportunities",
    "Improving social status",
    "Reducing poverty"
  ],
  answer: "Causing school dropout and limiting opportunities"
},
{
  question: "An outline map is useful because it:",
  options: [
    "Shows detailed relief",
    "Displays boundaries without names",
    "Shows climate patterns",
    "Represents population"
  ],
  answer: "Displays boundaries without names"
},
{
  question: "Why do many people living along Ghana�s coast engage in fishing?",
  options: [
    "Presence of fertile land",
    "Availability of water bodies",
    "High rainfall",
    "Government policy"
  ],
  answer: "Availability of water bodies"
},
{
  question: "Which of the following is most likely to cause conflict in a community?",
  options: [
    "Tolerance",
    "Misunderstanding",
    "Respect",
    "Unity"
  ],
  answer: "Misunderstanding"
},
{
  question: "The environment consists of living and:",
  options: [
    "Dead things only",
    "Non-living things",
    "Invisible things",
    "Artificial things"
  ],
  answer: "Non-living things"
},
{
  question: "Ghana is located in which region of the world?",
  options: [
    "Europe",
    "Africa",
    "Asia",
    "South America"
  ],
  answer: "Africa"
},
{
  question: "Which of the following is NOT a social problem?",
  options: [
    "Drug abuse",
    "Streetism",
    "Education",
    "Teenage pregnancy"
  ],
  answer: "Education"
},
{
  question: "What does the green colour in Ghana�s flag represent?",
  options: [
    "Gold resources",
    "Peace",
    "Forests and agriculture",
    "Unity"
  ],
  answer: "Forests and agriculture"
},
{
  question: "Who is the head of a family in traditional Ghanaian society?",
  options: [
    "Chief",
    "Father",
    "Abusuapanyin",
    "Elder"
  ],
  answer: "Abusuapanyin"
},
{
  question: "Why is it important to keep our surroundings clean?",
  options: [
    "To attract visitors",
    "To prevent diseases",
    "To win awards",
    "To impress others"
  ],
  answer: "To prevent diseases"
},
{
  question: "Human rights can best be described as:",
  options: [
    "Privileges for the rich",
    "Freedoms and entitlements of all people",
    "Government gifts",
    "Rules for children only"
  ],
  answer: "Freedoms and entitlements of all people"
},

{
  question: "Which of the following best explains why rules are important in society?",
  options: [
    "They restrict freedom completely",
    "They maintain order and guide behaviour",
    "They are only for leaders",
    "They apply only in schools"
  ],
  answer: "They maintain order and guide behaviour"
},
{
  question: "A good citizen contributes to national development mainly by:",
  options: [
    "Avoiding responsibilities",
    "Participating in community activities",
    "Ignoring laws",
    "Focusing only on personal needs"
  ],
  answer: "Participating in community activities"
},
{
  question: "Which of the following is a natural resource found in Ghana?",
  options: [
    "Plastic",
    "Gold",
    "Machines",
    "Clothing"
  ],
  answer: "Gold"
},
{
  question: "Why is education important in society?",
  options: [
    "It wastes time",
    "It helps individuals develop knowledge and skills",
    "It increases poverty",
    "It is only for children"
  ],
  answer: "It helps individuals develop knowledge and skills"
},
{
  question: "Which of the following is the main function of the family?",
  options: [
    "Producing goods",
    "Providing care and socialization",
    "Making laws",
    "Conducting elections"
  ],
  answer: "Providing care and socialization"
},
{
  question: "Which of the following behaviours promotes peace in a community?",
  options: [
    "Violence",
    "Tolerance",
    "Discrimination",
    "Hatred"
  ],
  answer: "Tolerance"
},
{
  question: "The Black Star in Ghana�s flag symbolizes:",
  options: [
    "Gold",
    "African freedom and unity",
    "Peace",
    "Agriculture"
  ],
  answer: "African freedom and unity"
},
{
  question: "Which of the following best explains unemployment?",
  options: [
    "People working full-time",
    "People without jobs but willing to work",
    "Students in school",
    "People on vacation"
  ],
  answer: "People without jobs but willing to work"
},
{
  question: "Which institution organizes elections in Ghana?",
  options: [
    "Police Service",
    "Electoral Commission",
    "Judiciary",
    "Parliament"
  ],
  answer: "Electoral Commission"
},
{
  question: "Which of the following is a major effect of environmental pollution?",
  options: [
    "Improved health",
    "Disease outbreak",
    "Better air quality",
    "Increased rainfall"
  ],
  answer: "Disease outbreak"
},
{
  question: "Which of the following best describes culture?",
  options: [
    "Only food and clothing",
    "Way of life of a people",
    "Government system",
    "Economic activity"
  ],
  answer: "Way of life of a people"
},
{
  question: "Which of the following helps prevent the spread of diseases?",
  options: [
    "Poor sanitation",
    "Regular hand washing",
    "Open defecation",
    "Ignoring hygiene"
  ],
  answer: "Regular hand washing"
},
{
  question: "Which of the following is a responsibility of government?",
  options: [
    "Cooking food",
    "Providing security",
    "Selling goods",
    "Farming"
  ],
  answer: "Providing security"
},
{
  question: "Which of the following is an example of a renewable resource?",
  options: [
    "Gold",
    "Petroleum",
    "Sunlight",
    "Coal"
  ],
  answer: "Sunlight"
},
{
  question: "Which of the following is most likely to reduce poverty?",
  options: [
    "Unemployment",
    "Education and skill training",
    "Ignoring work",
    "Laziness"
  ],
  answer: "Education and skill training"
},
{
  question: "Which of the following best explains democracy?",
  options: [
    "Rule by one person",
    "Rule by the people",
    "Military rule",
    "Colonial rule"
  ],
  answer: "Rule by the people"
},
{
  question: "Which of the following is a harmful social behaviour?",
  options: [
    "Respect",
    "Drug abuse",
    "Honesty",
    "Tolerance"
  ],
  answer: "Drug abuse"
},
{
  question: "Which of the following is a physical feature?",
  options: [
    "School",
    "Bridge",
    "River",
    "Road"
  ],
  answer: "River"
},
{
  question: "Which of the following is an example of civic responsibility?",
  options: [
    "Breaking laws",
    "Voting in elections",
    "Avoiding taxes",
    "Ignoring community issues"
  ],
  answer: "Voting in elections"
},
{
  question: "Why is it important to obey laws?",
  options: [
    "To avoid punishment only",
    "To maintain order and safety",
    "To impress leaders",
    "To reduce education"
  ],
  answer: "To maintain order and safety"
},

{
  question: "Which of the following situations best demonstrates responsible citizenship?",
  options: [
    "Avoiding community meetings",
    "Reporting a crime to authorities",
    "Ignoring national issues",
    "Refusing to vote"
  ],
  answer: "Reporting a crime to authorities"
},
{
  question: "Why is national unity important for development?",
  options: [
    "It encourages conflicts",
    "It promotes cooperation and peace",
    "It limits diversity",
    "It prevents education"
  ],
  answer: "It promotes cooperation and peace"
},
{
  question: "Which of the following is the most appropriate way to resolve conflict?",
  options: [
    "Fighting",
    "Dialogue and negotiation",
    "Ignoring the issue",
    "Blaming others"
  ],
  answer: "Dialogue and negotiation"
},
{
  question: "A community experiencing poor sanitation is most likely to face:",
  options: [
    "Improved health",
    "Disease outbreaks",
    "Economic growth",
    "Better living conditions"
  ],
  answer: "Disease outbreaks"
},
{
  question: "Which of the following best explains why taxes are important?",
  options: [
    "They reduce development",
    "They fund public services",
    "They increase poverty",
    "They benefit only leaders"
  ],
  answer: "They fund public services"
},
{
  question: "Which of the following activities contributes most to environmental degradation?",
  options: [
    "Tree planting",
    "Deforestation",
    "Recycling",
    "Sanitation"
  ],
  answer: "Deforestation"
},
{
  question: "Which of the following best explains human rights abuse?",
  options: [
    "Respecting freedoms",
    "Denying individuals their basic rights",
    "Promoting equality",
    "Protecting citizens"
  ],
  answer: "Denying individuals their basic rights"
},
{
  question: "Why is it important to preserve cultural heritage?",
  options: [
    "To forget traditions",
    "To maintain identity and values",
    "To promote foreign culture only",
    "To discourage unity"
  ],
  answer: "To maintain identity and values"
},
{
  question: "Which of the following is the best example of leadership?",
  options: [
    "Ignoring others",
    "Guiding and influencing people positively",
    "Forcing decisions",
    "Avoiding responsibility"
  ],
  answer: "Guiding and influencing people positively"
},
{
  question: "Which of the following best describes a constitution?",
  options: [
    "A set of school rules",
    "The supreme law of a country",
    "Traditional customs",
    "Religious beliefs"
  ],
  answer: "The supreme law of a country"
},
{
  question: "Which of the following best explains corruption?",
  options: [
    "Honesty in leadership",
    "Misuse of power for personal gain",
    "Serving the public",
    "Following rules"
  ],
  answer: "Misuse of power for personal gain"
},
{
  question: "Which of the following is a key feature of good governance?",
  options: [
    "Transparency and accountability",
    "Secrecy",
    "Dictatorship",
    "Bias"
  ],
  answer: "Transparency and accountability"
},
{
  question: "Why is education considered a human right?",
  options: [
    "It is optional",
    "It helps individuals develop and improve their lives",
    "It is only for the rich",
    "It is not important"
  ],
  answer: "It helps individuals develop and improve their lives"
},
{
  question: "Which of the following best explains gender equality?",
  options: [
    "Men are superior",
    "Women are superior",
    "Equal rights and opportunities for all genders",
    "Only men should lead"
  ],
  answer: "Equal rights and opportunities for all genders"
},
{
  question: "Which of the following is the most effective way to reduce unemployment?",
  options: [
    "Avoid education",
    "Promote skills training and entrepreneurship",
    "Ignore job creation",
    "Increase taxes only"
  ],
  answer: "Promote skills training and entrepreneurship"
},
{
  question: "Which of the following best explains urbanization?",
  options: [
    "Movement from cities to villages",
    "Movement from rural to urban areas",
    "Population decline",
    "Decrease in infrastructure"
  ],
  answer: "Movement from rural to urban areas"
},
{
  question: "Which of the following is the main aim of environmental conservation?",
  options: [
    "Destroy resources",
    "Protect and sustain natural resources",
    "Encourage pollution",
    "Limit development"
  ],
  answer: "Protect and sustain natural resources"
},
{
  question: "Which of the following best explains peer pressure?",
  options: [
    "Influence from adults",
    "Influence from friends of the same age",
    "Government influence",
    "Family pressure"
  ],
  answer: "Influence from friends of the same age"
},
{
  question: "Which of the following is the best way to promote discipline in schools?",
  options: [
    "Ignoring rules",
    "Enforcing rules fairly",
    "Encouraging bad behaviour",
    "Avoiding punishment"
  ],
  answer: "Enforcing rules fairly"
},
{
  question: "Which of the following best explains national symbols?",
  options: [
    "Objects with no meaning",
    "Representations of a country's identity",
    "Foreign items",
    "Temporary designs"
  ],
  answer: "Representations of a country's identity"
},

{
  question: "A student witnesses bullying in school but decides not to report it. Which value is the student failing to demonstrate?",
  options: [
    "Courage",
    "Honesty",
    "Respect",
    "Tolerance"
  ],
  answer: "Courage"
},
{
  question: "A community lacks clean water supply. Which action would best improve the situation?",
  options: [
    "Ignoring the issue",
    "Building proper sanitation systems",
    "Cutting down trees",
    "Increasing waste disposal"
  ],
  answer: "Building proper sanitation systems"
},
{
  question: "Which of the following situations best shows abuse of power?",
  options: [
    "A leader serving the people honestly",
    "A leader using public funds for personal benefit",
    "A teacher guiding students",
    "A parent caring for children"
  ],
  answer: "A leader using public funds for personal benefit"
},
{
  question: "A country experiences frequent conflicts among ethnic groups. What is the most effective solution?",
  options: [
    "Promoting discrimination",
    "Encouraging dialogue and unity",
    "Separating communities permanently",
    "Ignoring the problem"
  ],
  answer: "Encouraging dialogue and unity"
},
{
  question: "Which of the following best explains why laws are enforced?",
  options: [
    "To punish people only",
    "To maintain order and protect citizens",
    "To control education",
    "To restrict development"
  ],
  answer: "To maintain order and protect citizens"
},
{
  question: "A person who dumps waste into a river is most likely causing:",
  options: [
    "Soil fertility",
    "Water pollution",
    "Air purification",
    "Economic growth"
  ],
  answer: "Water pollution"
},
{
  question: "Which of the following is the most effective way to promote good health in a community?",
  options: [
    "Ignoring hygiene practices",
    "Encouraging proper sanitation and healthcare",
    "Reducing education",
    "Avoiding clean water"
  ],
  answer: "Encouraging proper sanitation and healthcare"
},
{
  question: "Which of the following situations best demonstrates respect for human rights?",
  options: [
    "Denying people education",
    "Allowing freedom of expression",
    "Forcing people to work",
    "Discriminating against minorities"
  ],
  answer: "Allowing freedom of expression"
},
{
  question: "A young person refuses to obey school rules. What is the most likely consequence?",
  options: [
    "Improved discipline",
    "Disorder and punishment",
    "Better academic performance",
    "Increased respect"
  ],
  answer: "Disorder and punishment"
},
{
  question: "Which of the following best explains sustainable development?",
  options: [
    "Using resources without limits",
    "Meeting present needs without harming future generations",
    "Ignoring environmental issues",
    "Focusing only on economic growth"
  ],
  answer: "Meeting present needs without harming future generations"
},
{
  question: "Which of the following is the most effective way to reduce crime in society?",
  options: [
    "Ignoring laws",
    "Strengthening law enforcement and education",
    "Encouraging violence",
    "Reducing police presence"
  ],
  answer: "Strengthening law enforcement and education"
},
{
  question: "Which of the following best explains leadership failure?",
  options: [
    "Serving the people",
    "Lack of accountability and responsibility",
    "Promoting development",
    "Encouraging unity"
  ],
  answer: "Lack of accountability and responsibility"
},
{
  question: "Which of the following is the best way to promote peace in schools?",
  options: [
    "Encouraging fights",
    "Promoting dialogue and respect",
    "Ignoring conflicts",
    "Punishing all students"
  ],
  answer: "Promoting dialogue and respect"
},
{
  question: "Which of the following situations best shows responsible use of natural resources?",
  options: [
    "Deforestation",
    "Overfishing",
    "Tree planting",
    "Pollution"
  ],
  answer: "Tree planting"
},
{
  question: "Which of the following best explains why corruption affects development?",
  options: [
    "It increases resources",
    "It misuses resources meant for public benefit",
    "It promotes transparency",
    "It improves governance"
  ],
  answer: "It misuses resources meant for public benefit"
},
{
  question: "Which of the following is the most effective way to ensure justice in society?",
  options: [
    "Bias and favoritism",
    "Fair and equal application of laws",
    "Ignoring crimes",
    "Selective punishment"
  ],
  answer: "Fair and equal application of laws"
},
{
  question: "A student studies hard and avoids bad influences. Which value is being demonstrated?",
  options: [
    "Indiscipline",
    "Self-control",
    "Corruption",
    "Irresponsibility"
  ],
  answer: "Self-control"
},
{
  question: "Which of the following best explains why communities need cooperation?",
  options: [
    "To create conflict",
    "To achieve common goals",
    "To promote division",
    "To reduce development"
  ],
  answer: "To achieve common goals"
},
{
  question: "Which of the following is the most appropriate response to peer pressure?",
  options: [
    "Always follow friends",
    "Make independent and responsible decisions",
    "Ignore consequences",
    "Avoid thinking"
  ],
  answer: "Make independent and responsible decisions"
},
{
  question: "Which of the following best explains national development?",
  options: [
    "Decline in infrastructure",
    "Improvement in the standard of living",
    "Increase in poverty",
    "Reduction in education"
  ],
  answer: "Improvement in the standard of living"
},

{
  question: "Which of the following best explains why discipline is important in society?",
  options: [
    "It limits freedom completely",
    "It promotes order and responsible behaviour",
    "It benefits only leaders",
    "It reduces education"
  ],
  answer: "It promotes order and responsible behaviour"
},
{
  question: "Which of the following actions best demonstrates patriotism?",
  options: [
    "Destroying public property",
    "Protecting national resources",
    "Avoiding responsibilities",
    "Ignoring national issues"
  ],
  answer: "Protecting national resources"
},
{
  question: "Which of the following is most likely to lead to environmental sustainability?",
  options: [
    "Overexploitation of resources",
    "Proper waste management",
    "Deforestation",
    "Pollution"
  ],
  answer: "Proper waste management"
},
{
  question: "Which of the following best explains social inequality?",
  options: [
    "Equal opportunities for all",
    "Unequal distribution of resources and opportunities",
    "Improved living standards",
    "Fair treatment of all people"
  ],
  answer: "Unequal distribution of resources and opportunities"
},
{
  question: "Which of the following is the main purpose of laws in a country?",
  options: [
    "To create confusion",
    "To regulate behaviour and maintain order",
    "To limit development",
    "To control education"
  ],
  answer: "To regulate behaviour and maintain order"
},
{
  question: "Which of the following best explains the role of education in national development?",
  options: [
    "It increases ignorance",
    "It equips individuals with skills and knowledge",
    "It reduces productivity",
    "It promotes unemployment"
  ],
  answer: "It equips individuals with skills and knowledge"
},
{
  question: "Which of the following is the most effective way to prevent drug abuse among youth?",
  options: [
    "Ignoring the issue",
    "Education and awareness",
    "Encouraging experimentation",
    "Punishment only"
  ],
  answer: "Education and awareness"
},
{
  question: "Which of the following best explains why voting is important?",
  options: [
    "It wastes time",
    "It allows citizens to choose leaders",
    "It increases conflicts",
    "It benefits only politicians"
  ],
  answer: "It allows citizens to choose leaders"
},
{
  question: "Which of the following is the best way to promote environmental cleanliness?",
  options: [
    "Dumping waste anywhere",
    "Practicing proper sanitation",
    "Ignoring waste management",
    "Burning plastics openly"
  ],
  answer: "Practicing proper sanitation"
},
{
  question: "Which of the following best explains the importance of unity?",
  options: [
    "It promotes division",
    "It strengthens cooperation and development",
    "It limits progress",
    "It causes conflicts"
  ],
  answer: "It strengthens cooperation and development"
},
{
  question: "Which of the following best explains the concept of leadership?",
  options: [
    "Forcing people to obey",
    "Influencing and guiding others towards goals",
    "Ignoring responsibilities",
    "Avoiding decisions"
  ],
  answer: "Influencing and guiding others towards goals"
},
{
  question: "Which of the following is the most effective way to manage conflicts?",
  options: [
    "Violence",
    "Dialogue and compromise",
    "Ignoring the issue",
    "Blaming others"
  ],
  answer: "Dialogue and compromise"
},
{
  question: "Which of the following best explains why rules are necessary in schools?",
  options: [
    "To create fear",
    "To maintain discipline and order",
    "To punish students",
    "To limit learning"
  ],
  answer: "To maintain discipline and order"
},
{
  question: "Which of the following is the best example of honesty?",
  options: [
    "Cheating in exams",
    "Telling the truth even when it is difficult",
    "Stealing property",
    "Lying to avoid punishment"
  ],
  answer: "Telling the truth even when it is difficult"
},
{
  question: "Which of the following best explains why communities need laws?",
  options: [
    "To create confusion",
    "To ensure order and protect citizens",
    "To increase conflicts",
    "To reduce development"
  ],
  answer: "To ensure order and protect citizens"
},
{
  question: "Which of the following is the most effective way to promote good behaviour?",
  options: [
    "Ignoring misconduct",
    "Encouraging positive values and discipline",
    "Punishment only",
    "Avoiding rules"
  ],
  answer: "Encouraging positive values and discipline"
},
{
  question: "Which of the following best explains the importance of cooperation?",
  options: [
    "It promotes conflict",
    "It helps achieve common goals",
    "It reduces development",
    "It encourages selfishness"
  ],
  answer: "It helps achieve common goals"
},
{
  question: "Which of the following best explains civic responsibility?",
  options: [
    "Ignoring national duties",
    "Active participation in national activities",
    "Avoiding laws",
    "Focusing only on personal gain"
  ],
  answer: "Active participation in national activities"
},
{
  question: "Which of the following is the best way to reduce environmental pollution?",
  options: [
    "Dumping waste into rivers",
    "Proper waste disposal and recycling",
    "Burning waste openly",
    "Ignoring sanitation"
  ],
  answer: "Proper waste disposal and recycling"
},
{
  question: "Which of the following best explains national identity?",
  options: [
    "Foreign culture only",
    "Shared values, symbols, and traditions of a country",
    "Individual beliefs only",
    "Temporary practices"
  ],
  answer: "Shared values, symbols, and traditions of a country"
},

{
  question: "Which of the following best explains why cooperation is important in group work?",
  options: [
    "It creates competition",
    "It helps achieve shared goals effectively",
    "It reduces participation",
    "It causes misunderstanding"
  ],
  answer: "It helps achieve shared goals effectively"
},
{
  question: "A person who respects others' opinions is demonstrating:",
  options: [
    "Tolerance",
    "Weakness",
    "Pride",
    "Fear"
  ],
  answer: "Tolerance"
},
{
  question: "Which of the following is the best example of environmental conservation?",
  options: [
    "Burning forests",
    "Planting trees",
    "Dumping waste in rivers",
    "Overfishing"
  ],
  answer: "Planting trees"
},
{
  question: "Why is it important to obey traffic rules?",
  options: [
    "To avoid movement",
    "To ensure safety on roads",
    "To increase accidents",
    "To delay travel"
  ],
  answer: "To ensure safety on roads"
},
{
  question: "Which of the following best explains civic education?",
  options: [
    "Teaching farming only",
    "Educating citizens about their rights and responsibilities",
    "Training soldiers",
    "Teaching sports"
  ],
  answer: "Educating citizens about their rights and responsibilities"
},
{
  question: "Which of the following is a negative effect of unemployment?",
  options: [
    "Increased income",
    "Higher standard of living",
    "Increase in poverty",
    "Economic stability"
  ],
  answer: "Increase in poverty"
},
{
  question: "Which of the following best explains peace?",
  options: [
    "Absence of conflict",
    "Constant fighting",
    "Disagreement",
    "Competition"
  ],
  answer: "Absence of conflict"
},
{
  question: "A student who studies regularly is likely to:",
  options: [
    "Fail exams",
    "Perform better academically",
    "Lose knowledge",
    "Avoid success"
  ],
  answer: "Perform better academically"
},
{
  question: "Which of the following best explains why laws should be obeyed?",
  options: [
    "To create fear",
    "To maintain order in society",
    "To benefit leaders only",
    "To reduce freedom"
  ],
  answer: "To maintain order in society"
},
{
  question: "Which of the following is an example of a social problem?",
  options: [
    "Education",
    "Drug abuse",
    "Employment",
    "Unity"
  ],
  answer: "Drug abuse"
},
{
  question: "Which of the following best explains why unity is needed in a country?",
  options: [
    "To promote division",
    "To enhance development and stability",
    "To reduce cooperation",
    "To increase conflicts"
  ],
  answer: "To enhance development and stability"
},
{
  question: "Which of the following is a duty of a good citizen?",
  options: [
    "Breaking laws",
    "Participating in elections",
    "Avoiding taxes",
    "Ignoring rules"
  ],
  answer: "Participating in elections"
},
{
  question: "Which of the following best explains leadership responsibility?",
  options: [
    "Ignoring followers",
    "Guiding and serving people effectively",
    "Avoiding decisions",
    "Using power selfishly"
  ],
  answer: "Guiding and serving people effectively"
},
{
  question: "Which of the following best explains why sanitation is important?",
  options: [
    "To create dirt",
    "To prevent diseases",
    "To increase pollution",
    "To waste resources"
  ],
  answer: "To prevent diseases"
},
{
  question: "Which of the following best explains cultural diversity?",
  options: [
    "Only one culture exists",
    "Different cultures exist within a society",
    "No culture exists",
    "Foreign culture only"
  ],
  answer: "Different cultures exist within a society"
},
{
  question: "Which of the following is the best way to reduce conflicts in society?",
  options: [
    "Violence",
    "Dialogue and understanding",
    "Ignoring issues",
    "Blaming others"
  ],
  answer: "Dialogue and understanding"
},
{
  question: "Which of the following best explains national symbols?",
  options: [
    "Objects without meaning",
    "Represent a country's identity",
    "Temporary items",
    "Foreign symbols"
  ],
  answer: "Represent a country's identity"
},
{
  question: "Which of the following best explains discipline?",
  options: [
    "Disobedience",
    "Self-control and respect for rules",
    "Irresponsibility",
    "Carelessness"
  ],
  answer: "Self-control and respect for rules"
},
{
  question: "Which of the following is the best example of responsibility?",
  options: [
    "Avoiding duties",
    "Completing assigned tasks",
    "Ignoring rules",
    "Blaming others"
  ],
  answer: "Completing assigned tasks"
},
{
  question: "Which of the following best explains development?",
  options: [
    "Decline in living conditions",
    "Improvement in quality of life",
    "Increase in poverty",
    "Reduction in education"
  ],
  answer: "Improvement in quality of life"
},

{
  question: "A student refuses to join others in cheating during an exam. Which value is the student demonstrating?",
  options: [
    "Dishonesty",
    "Integrity",
    "Fear",
    "Pride"
  ],
  answer: "Integrity"
},
{
  question: "Which of the following best explains why community participation is important?",
  options: [
    "It delays development",
    "It helps solve local problems collectively",
    "It creates confusion",
    "It reduces cooperation"
  ],
  answer: "It helps solve local problems collectively"
},
{
  question: "Which of the following actions best promotes environmental protection?",
  options: [
    "Indiscriminate dumping",
    "Afforestation",
    "Burning plastics",
    "Overgrazing"
  ],
  answer: "Afforestation"
},
{
  question: "Which of the following best explains justice?",
  options: [
    "Partial treatment",
    "Fairness and equality",
    "Bias",
    "Punishment only"
  ],
  answer: "Fairness and equality"
},
{
  question: "A leader who listens to the opinions of others is demonstrating:",
  options: [
    "Weakness",
    "Democratic leadership",
    "Dictatorship",
    "Negligence"
  ],
  answer: "Democratic leadership"
},
{
  question: "Which of the following is the most effective way to reduce teenage pregnancy?",
  options: [
    "Ignoring the issue",
    "Providing education and guidance",
    "Encouraging early marriage",
    "Punishment only"
  ],
  answer: "Providing education and guidance"
},
{
  question: "Which of the following best explains corruption in public service?",
  options: [
    "Serving honestly",
    "Using public office for personal gain",
    "Promoting transparency",
    "Following rules"
  ],
  answer: "Using public office for personal gain"
},
{
  question: "Which of the following is a positive effect of education?",
  options: [
    "Ignorance",
    "Improved decision-making",
    "Unemployment",
    "Poverty"
  ],
  answer: "Improved decision-making"
},
{
  question: "Which of the following best explains national cohesion?",
  options: [
    "Division among people",
    "Unity and togetherness",
    "Conflict",
    "Competition"
  ],
  answer: "Unity and togetherness"
},
{
  question: "Which of the following is the best way to handle peer pressure?",
  options: [
    "Follow friends blindly",
    "Make informed and independent choices",
    "Ignore consequences",
    "Avoid thinking"
  ],
  answer: "Make informed and independent choices"
},
{
  question: "Which of the following best explains why sanitation laws are enforced?",
  options: [
    "To punish people",
    "To promote cleanliness and health",
    "To increase waste",
    "To reduce development"
  ],
  answer: "To promote cleanliness and health"
},
{
  question: "Which of the following is the main role of the family?",
  options: [
    "Passing laws",
    "Providing care and upbringing",
    "Conducting elections",
    "Maintaining security"
  ],
  answer: "Providing care and upbringing"
},
{
  question: "Which of the following best explains leadership accountability?",
  options: [
    "Avoiding responsibility",
    "Answering for actions and decisions",
    "Ignoring feedback",
    "Blaming others"
  ],
  answer: "Answering for actions and decisions"
},
{
  question: "Which of the following is the best way to prevent conflicts?",
  options: [
    "Violence",
    "Communication and understanding",
    "Ignoring issues",
    "Blaming others"
  ],
  answer: "Communication and understanding"
},
{
  question: "Which of the following best explains the importance of laws in schools?",
  options: [
    "To create fear",
    "To ensure discipline and order",
    "To limit learning",
    "To punish students only"
  ],
  answer: "To ensure discipline and order"
},
{
  question: "Which of the following best explains why people migrate?",
  options: [
    "To avoid development",
    "To seek better opportunities",
    "To reduce population",
    "To avoid education"
  ],
  answer: "To seek better opportunities"
},
{
  question: "Which of the following is the most effective way to reduce pollution?",
  options: [
    "Dumping waste",
    "Recycling and proper disposal",
    "Burning waste",
    "Ignoring sanitation"
  ],
  answer: "Recycling and proper disposal"
},
{
  question: "Which of the following best explains respect?",
  options: [
    "Insulting others",
    "Valuing others� opinions and rights",
    "Ignoring people",
    "Discriminating"
  ],
  answer: "Valuing others� opinions and rights"
},
{
  question: "Which of the following best explains development in a country?",
  options: [
    "Increase in poverty",
    "Improvement in infrastructure and living standards",
    "Reduction in education",
    "Decline in economy"
  ],
  answer: "Improvement in infrastructure and living standards"
},
{
  question: "Which of the following is the best example of good citizenship?",
  options: [
    "Breaking laws",
    "Participating in community service",
    "Avoiding responsibilities",
    "Ignoring national issues"
  ],
  answer: "Participating in community service"
},

{
  question: "A student returns a lost wallet to its owner without taking anything. Which value is demonstrated?",
  options: [
    "Greed",
    "Honesty",
    "Pride",
    "Fear"
  ],
  answer: "Honesty"
},
{
  question: "Which of the following best explains why laws are necessary in a country?",
  options: [
    "To create fear",
    "To maintain order and protect citizens",
    "To control education",
    "To increase conflict"
  ],
  answer: "To maintain order and protect citizens"
},
{
  question: "Which of the following actions best promotes national unity?",
  options: [
    "Encouraging tribalism",
    "Promoting tolerance and respect",
    "Ignoring minorities",
    "Creating divisions"
  ],
  answer: "Promoting tolerance and respect"
},
{
  question: "Which of the following is the most effective way to protect the environment?",
  options: [
    "Deforestation",
    "Proper waste management",
    "Overfishing",
    "Burning plastics"
  ],
  answer: "Proper waste management"
},
{
  question: "Which of the following best explains democracy?",
  options: [
    "Rule by one person",
    "Rule by the people",
    "Military rule",
    "Colonial rule"
  ],
  answer: "Rule by the people"
},
{
  question: "Which of the following is the best way to reduce conflicts in society?",
  options: [
    "Violence",
    "Dialogue and compromise",
    "Ignoring problems",
    "Blaming others"
  ],
  answer: "Dialogue and compromise"
},
{
  question: "Which of the following best explains why education is important?",
  options: [
    "It wastes time",
    "It develops knowledge and skills",
    "It increases poverty",
    "It is not necessary"
  ],
  answer: "It develops knowledge and skills"
},
{
  question: "Which of the following is the main aim of environmental conservation?",
  options: [
    "Destroy resources",
    "Protect natural resources",
    "Encourage pollution",
    "Limit development"
  ],
  answer: "Protect natural resources"
},
{
  question: "Which of the following best explains leadership?",
  options: [
    "Forcing people to obey",
    "Guiding and influencing others",
    "Ignoring responsibilities",
    "Avoiding decisions"
  ],
  answer: "Guiding and influencing others"
},
{
  question: "Which of the following is the best example of responsibility?",
  options: [
    "Ignoring duties",
    "Completing assigned tasks",
    "Blaming others",
    "Avoiding work"
  ],
  answer: "Completing assigned tasks"
},
{
  question: "Which of the following best explains civic responsibility?",
  options: [
    "Ignoring national duties",
    "Participating in national activities",
    "Avoiding laws",
    "Focusing only on personal gain"
  ],
  answer: "Participating in national activities"
},
{
  question: "Which of the following is a major cause of environmental pollution?",
  options: [
    "Tree planting",
    "Industrial waste",
    "Recycling",
    "Clean energy"
  ],
  answer: "Industrial waste"
},
{
  question: "Which of the following best explains discipline?",
  options: [
    "Disobedience",
    "Self-control and respect for rules",
    "Irresponsibility",
    "Carelessness"
  ],
  answer: "Self-control and respect for rules"
},
{
  question: "Which of the following is the best way to promote good health?",
  options: [
    "Poor sanitation",
    "Balanced diet and hygiene",
    "Ignoring exercise",
    "Avoiding clean water"
  ],
  answer: "Balanced diet and hygiene"
},
{
  question: "Which of the following best explains unity?",
  options: [
    "Division",
    "Togetherness and cooperation",
    "Conflict",
    "Competition"
  ],
  answer: "Togetherness and cooperation"
},
{
  question: "Which of the following is the most effective way to reduce unemployment?",
  options: [
    "Ignoring job creation",
    "Promoting skills training",
    "Avoiding education",
    "Reducing industries"
  ],
  answer: "Promoting skills training"
},
{
  question: "Which of the following best explains national identity?",
  options: [
    "Foreign culture only",
    "Shared values and traditions",
    "Individual beliefs only",
    "Temporary practices"
  ],
  answer: "Shared values and traditions"
},
{
  question: "Which of the following is the best way to prevent social problems?",
  options: [
    "Ignoring issues",
    "Education and awareness",
    "Encouraging bad behaviour",
    "Avoiding responsibility"
  ],
  answer: "Education and awareness"
},
{
  question: "Which of the following best explains cooperation?",
  options: [
    "Working alone",
    "Working together to achieve goals",
    "Creating conflict",
    "Avoiding responsibility"
  ],
  answer: "Working together to achieve goals"
},
{
  question: "Which of the following best explains development?",
  options: [
    "Increase in poverty",
    "Improvement in living conditions",
    "Reduction in education",
    "Decline in economy"
  ],
  answer: "Improvement in living conditions"
},

{
  question: "A student refuses to join friends in vandalizing school property. Which value is being demonstrated?",
  options: [
    "Irresponsibility",
    "Discipline",
    "Fear",
    "Weakness"
  ],
  answer: "Discipline"
},
{
  question: "Which of the following best explains why citizens should pay taxes?",
  options: [
    "To enrich leaders",
    "To fund public services and development",
    "To reduce population",
    "To control elections"
  ],
  answer: "To fund public services and development"
},
{
  question: "Which of the following actions would best reduce environmental degradation?",
  options: [
    "Illegal mining",
    "Afforestation and proper land use",
    "Deforestation",
    "Burning bushes"
  ],
  answer: "Afforestation and proper land use"
},
{
  question: "Which of the following best explains rule of law?",
  options: [
    "Leaders are above the law",
    "Everyone is subject to the law equally",
    "Only citizens obey laws",
    "Laws apply only in cities"
  ],
  answer: "Everyone is subject to the law equally"
},
{
  question: "A community leader uses funds meant for development for personal use. This is an example of:",
  options: [
    "Accountability",
    "Corruption",
    "Leadership",
    "Honesty"
  ],
  answer: "Corruption"
},
{
  question: "Which of the following is the best way to promote peace among different ethnic groups?",
  options: [
    "Segregation",
    "Tolerance and dialogue",
    "Competition",
    "Ignoring differences"
  ],
  answer: "Tolerance and dialogue"
},
{
  question: "Which of the following best explains why education reduces poverty?",
  options: [
    "It increases laziness",
    "It provides skills for employment",
    "It reduces knowledge",
    "It limits opportunities"
  ],
  answer: "It provides skills for employment"
},
{
  question: "Which of the following is a negative effect of rapid urbanization?",
  options: [
    "Improved housing",
    "Overcrowding and pressure on resources",
    "Better sanitation",
    "Increased job opportunities"
  ],
  answer: "Overcrowding and pressure on resources"
},
{
  question: "Which of the following best explains good governance?",
  options: [
    "Lack of transparency",
    "Accountability and fairness",
    "Corruption",
    "Bias"
  ],
  answer: "Accountability and fairness"
},
{
  question: "Which of the following actions best shows patriotism?",
  options: [
    "Destroying public property",
    "Protecting national assets",
    "Avoiding responsibilities",
    "Breaking laws"
  ],
  answer: "Protecting national assets"
},
{
  question: "Which of the following best explains human rights?",
  options: [
    "Privileges for leaders only",
    "Basic freedoms of all individuals",
    "Government gifts",
    "Rules for children only"
  ],
  answer: "Basic freedoms of all individuals"
},
{
  question: "Which of the following is the most effective way to control population growth?",
  options: [
    "Ignoring education",
    "Family planning and education",
    "Increasing birth rate",
    "Avoiding healthcare"
  ],
  answer: "Family planning and education"
},
{
  question: "Which of the following best explains conflict resolution?",
  options: [
    "Fighting",
    "Dialogue and compromise",
    "Ignoring issues",
    "Blaming others"
  ],
  answer: "Dialogue and compromise"
},
{
  question: "Which of the following is the best way to promote discipline in society?",
  options: [
    "Ignoring rules",
    "Enforcing laws fairly",
    "Encouraging misconduct",
    "Avoiding punishment"
  ],
  answer: "Enforcing laws fairly"
},
{
  question: "Which of the following best explains leadership qualities?",
  options: [
    "Selfishness",
    "Responsibility and integrity",
    "Corruption",
    "Negligence"
  ],
  answer: "Responsibility and integrity"
},
{
  question: "Which of the following is the best way to ensure environmental sustainability?",
  options: [
    "Overuse of resources",
    "Proper management of resources",
    "Pollution",
    "Deforestation"
  ],
  answer: "Proper management of resources"
},
{
  question: "Which of the following best explains equality?",
  options: [
    "Discrimination",
    "Fair treatment of all individuals",
    "Bias",
    "Favoritism"
  ],
  answer: "Fair treatment of all individuals"
},
{
  question: "Which of the following is the most effective way to reduce crime?",
  options: [
    "Ignoring laws",
    "Education and strict law enforcement",
    "Encouraging violence",
    "Reducing police presence"
  ],
  answer: "Education and strict law enforcement"
},
{
  question: "Which of the following best explains responsibility?",
  options: [
    "Avoiding duties",
    "Being accountable for actions",
    "Blaming others",
    "Ignoring rules"
  ],
  answer: "Being accountable for actions"
},
{
  question: "Which of the following best explains national development?",
  options: [
    "Increase in poverty",
    "Improvement in infrastructure and living standards",
    "Reduction in education",
    "Decline in economy"
  ],
  answer: "Improvement in infrastructure and living standards"
},

{
  question: "A student refuses to cheat even when others are doing so. Which value is being demonstrated?",
  options: [
    "Dishonesty",
    "Integrity",
    "Fear",
    "Weakness"
  ],
  answer: "Integrity"
},
{
  question: "Which of the following best explains why national resources should be protected?",
  options: [
    "To benefit only leaders",
    "To ensure sustainable development",
    "To reduce economic growth",
    "To increase conflicts"
  ],
  answer: "To ensure sustainable development"
},
{
  question: "Which of the following is the most effective way to promote peace in a community?",
  options: [
    "Encouraging violence",
    "Dialogue and mutual respect",
    "Ignoring conflicts",
    "Separating groups"
  ],
  answer: "Dialogue and mutual respect"
},
{
  question: "Which of the following best explains why laws apply to everyone?",
  options: [
    "To favour leaders",
    "To ensure fairness and equality",
    "To punish citizens only",
    "To limit development"
  ],
  answer: "To ensure fairness and equality"
},
{
  question: "Which of the following is a major effect of corruption?",
  options: [
    "Improved development",
    "Misuse of public funds",
    "Increased transparency",
    "Better governance"
  ],
  answer: "Misuse of public funds"
},
{
  question: "Which of the following actions best shows good citizenship?",
  options: [
    "Destroying public property",
    "Participating in community development",
    "Avoiding responsibilities",
    "Ignoring laws"
  ],
  answer: "Participating in community development"
},
{
  question: "Which of the following best explains environmental pollution?",
  options: [
    "Clean environment",
    "Contamination of the environment",
    "Proper waste management",
    "Natural protection"
  ],
  answer: "Contamination of the environment"
},
{
  question: "Which of the following is the most effective way to prevent conflicts?",
  options: [
    "Violence",
    "Communication and understanding",
    "Ignoring issues",
    "Blaming others"
  ],
  answer: "Communication and understanding"
},
{
  question: "Which of the following best explains leadership?",
  options: [
    "Forcing others",
    "Guiding and influencing people",
    "Avoiding responsibility",
    "Ignoring followers"
  ],
  answer: "Guiding and influencing people"
},
{
  question: "Which of the following is the best example of discipline?",
  options: [
    "Breaking rules",
    "Obeying rules and showing self-control",
    "Ignoring instructions",
    "Blaming others"
  ],
  answer: "Obeying rules and showing self-control"
},
{
  question: "Which of the following best explains why education is important?",
  options: [
    "It increases poverty",
    "It develops knowledge and skills",
    "It wastes time",
    "It is unnecessary"
  ],
  answer: "It develops knowledge and skills"
},
{
  question: "Which of the following is the best way to reduce unemployment?",
  options: [
    "Ignoring education",
    "Promoting skills and entrepreneurship",
    "Reducing industries",
    "Avoiding training"
  ],
  answer: "Promoting skills and entrepreneurship"
},
{
  question: "Which of the following best explains unity?",
  options: [
    "Division",
    "Togetherness and cooperation",
    "Conflict",
    "Competition"
  ],
  answer: "Togetherness and cooperation"
},
{
  question: "Which of the following is the most effective way to reduce crime?",
  options: [
    "Ignoring laws",
    "Strict law enforcement and education",
    "Encouraging violence",
    "Reducing police presence"
  ],
  answer: "Strict law enforcement and education"
},
{
  question: "Which of the following best explains responsibility?",
  options: [
    "Avoiding duties",
    "Being accountable for actions",
    "Blaming others",
    "Ignoring rules"
  ],
  answer: "Being accountable for actions"
},
{
  question: "Which of the following best explains sustainable development?",
  options: [
    "Using resources without limits",
    "Meeting present needs without affecting future generations",
    "Ignoring environmental issues",
    "Focusing only on profits"
  ],
  answer: "Meeting present needs without affecting future generations"
},
{
  question: "Which of the following is the best example of honesty?",
  options: [
    "Cheating",
    "Telling the truth always",
    "Stealing",
    "Lying"
  ],
  answer: "Telling the truth always"
},
{
  question: "Which of the following best explains civic responsibility?",
  options: [
    "Ignoring national duties",
    "Active participation in national activities",
    "Avoiding laws",
    "Focusing on self-interest"
  ],
  answer: "Active participation in national activities"
},
{
  question: "Which of the following is the best way to protect the environment?",
  options: [
    "Deforestation",
    "Proper waste disposal and conservation",
    "Pollution",
    "Overuse of resources"
  ],
  answer: "Proper waste disposal and conservation"
},
{
  question: "Which of the following best explains development?",
  options: [
    "Increase in poverty",
    "Improvement in living standards",
    "Reduction in education",
    "Decline in economy"
  ],
  answer: "Improvement in living standards"
},

{
  question: "A student refuses to damage school property even when pressured by friends. Which value is demonstrated?",
  options: [
    "Indiscipline",
    "Integrity",
    "Fear",
    "Weakness"
  ],
  answer: "Integrity"
},
{
  question: "Which of the following best explains why citizens should obey laws?",
  options: [
    "To benefit leaders only",
    "To maintain order and safety in society",
    "To reduce freedom",
    "To create fear"
  ],
  answer: "To maintain order and safety in society"
},
{
  question: "Which of the following is the most effective way to reduce environmental pollution?",
  options: [
    "Dumping waste in rivers",
    "Proper waste management and recycling",
    "Burning plastics",
    "Ignoring sanitation"
  ],
  answer: "Proper waste management and recycling"
},
{
  question: "Which of the following best explains democracy?",
  options: [
    "Rule by one person",
    "Rule by the people",
    "Military control",
    "Colonial rule"
  ],
  answer: "Rule by the people"
},
{
  question: "Which of the following is the best example of good leadership?",
  options: [
    "Using power for personal gain",
    "Serving and guiding people responsibly",
    "Ignoring followers",
    "Avoiding decisions"
  ],
  answer: "Serving and guiding people responsibly"
},
{
  question: "Which of the following best explains corruption?",
  options: [
    "Honest service",
    "Misuse of power for personal benefit",
    "Transparency",
    "Accountability"
  ],
  answer: "Misuse of power for personal benefit"
},
{
  question: "Which of the following actions best promotes peace in a community?",
  options: [
    "Encouraging violence",
    "Dialogue and mutual understanding",
    "Ignoring conflicts",
    "Separating groups"
  ],
  answer: "Dialogue and mutual understanding"
},
{
  question: "Which of the following best explains responsibility?",
  options: [
    "Avoiding duties",
    "Being accountable for actions",
    "Blaming others",
    "Ignoring rules"
  ],
  answer: "Being accountable for actions"
},
{
  question: "Which of the following is the most effective way to reduce unemployment?",
  options: [
    "Avoiding education",
    "Promoting skills training and entrepreneurship",
    "Reducing industries",
    "Ignoring job creation"
  ],
  answer: "Promoting skills training and entrepreneurship"
},
{
  question: "Which of the following best explains environmental conservation?",
  options: [
    "Destroying resources",
    "Protecting and managing natural resources",
    "Encouraging pollution",
    "Ignoring the environment"
  ],
  answer: "Protecting and managing natural resources"
},
{
  question: "Which of the following best explains unity?",
  options: [
    "Division",
    "Togetherness and cooperation",
    "Conflict",
    "Competition"
  ],
  answer: "Togetherness and cooperation"
},
{
  question: "Which of the following is the best example of discipline?",
  options: [
    "Breaking rules",
    "Following rules and showing self-control",
    "Ignoring instructions",
    "Blaming others"
  ],
  answer: "Following rules and showing self-control"
},
{
  question: "Which of the following best explains why education is important?",
  options: [
    "It increases poverty",
    "It equips individuals with knowledge and skills",
    "It wastes time",
    "It is unnecessary"
  ],
  answer: "It equips individuals with knowledge and skills"
},
{
  question: "Which of the following is the best way to reduce crime in society?",
  options: [
    "Ignoring laws",
    "Effective law enforcement and education",
    "Encouraging violence",
    "Reducing police presence"
  ],
  answer: "Effective law enforcement and education"
},
{
  question: "Which of the following best explains civic responsibility?",
  options: [
    "Ignoring national duties",
    "Participating actively in national development",
    "Avoiding laws",
    "Focusing on personal gain"
  ],
  answer: "Participating actively in national development"
},
{
  question: "Which of the following is the best example of honesty?",
  options: [
    "Cheating in exams",
    "Telling the truth even when difficult",
    "Stealing",
    "Lying"
  ],
  answer: "Telling the truth even when difficult"
},
{
  question: "Which of the following best explains sustainable development?",
  options: [
    "Using resources without limits",
    "Meeting present needs without harming future generations",
    "Ignoring environmental issues",
    "Focusing only on profits"
  ],
  answer: "Meeting present needs without harming future generations"
},
{
  question: "Which of the following is the best way to protect natural resources?",
  options: [
    "Deforestation",
    "Conservation and proper use",
    "Pollution",
    "Overexploitation"
  ],
  answer: "Conservation and proper use"
},
{
  question: "Which of the following best explains national identity?",
  options: [
    "Foreign culture only",
    "Shared values, traditions and symbols",
    "Individual beliefs only",
    "Temporary practices"
  ],
  answer: "Shared values, traditions and symbols"
},
{
  question: "Which of the following best explains development?",
  options: [
    "Increase in poverty",
    "Improvement in standard of living",
    "Reduction in education",
    "Decline in economy"
  ],
  answer: "Improvement in standard of living"
},

{
  question: "A community project fails because members refuse to contribute ideas and effort. Which factor is missing?",
  options: [
    "Competition",
    "Cooperation",
    "Leadership",
    "Independence"
  ],
  answer: "Cooperation"
},
{
  question: "A leader takes decisions without consulting others and ignores public opinion. Which leadership style is being practiced?",
  options: [
    "Democratic",
    "Autocratic",
    "Participatory",
    "Consultative"
  ],
  answer: "Autocratic"
},
{
  question: "A town experiences frequent outbreaks of diseases due to poor waste disposal. What is the most likely cause?",
  options: [
    "Proper sanitation",
    "Environmental pollution",
    "Good hygiene",
    "Clean water supply"
  ],
  answer: "Environmental pollution"
},
{
  question: "A student always accepts responsibility for mistakes and corrects them. Which value is demonstrated?",
  options: [
    "Irresponsibility",
    "Accountability",
    "Dishonesty",
    "Negligence"
  ],
  answer: "Accountability"
},
{
  question: "A country experiences slow development because leaders misuse public funds. Which problem is illustrated?",
  options: [
    "Transparency",
    "Corruption",
    "Accountability",
    "Leadership"
  ],
  answer: "Corruption"
},
{
  question: "A group of students refuse to follow school rules, leading to disorder. Which concept is lacking?",
  options: [
    "Freedom",
    "Discipline",
    "Education",
    "Leadership"
  ],
  answer: "Discipline"
},
{
  question: "A farmer cuts down trees continuously without replacing them. What is the likely long-term effect?",
  options: [
    "Environmental conservation",
    "Deforestation",
    "Afforestation",
    "Sustainability"
  ],
  answer: "Deforestation"
},
{
  question: "A student votes during a school election. Which civic responsibility is being demonstrated?",
  options: [
    "Obedience",
    "Participation",
    "Leadership",
    "Discipline"
  ],
  answer: "Participation"
},
{
  question: "A society promotes equal opportunities for all citizens regardless of background. Which principle is being practiced?",
  options: [
    "Bias",
    "Equality",
    "Discrimination",
    "Favoritism"
  ],
  answer: "Equality"
},
{
  question: "A community resolves disputes through discussion and agreement rather than violence. Which method is being used?",
  options: [
    "Conflict escalation",
    "Conflict resolution",
    "Competition",
    "Division"
  ],
  answer: "Conflict resolution"
},
{
  question: "A student refuses to engage in examination malpractice despite peer pressure. Which value is demonstrated?",
  options: [
    "Weakness",
    "Integrity",
    "Fear",
    "Negligence"
  ],
  answer: "Integrity"
},
{
  question: "A government ensures that laws apply equally to all citizens. Which principle is being upheld?",
  options: [
    "Corruption",
    "Rule of law",
    "Bias",
    "Favoritism"
  ],
  answer: "Rule of law"
},
{
  question: "A community plants trees to replace those cut down. What practice is this?",
  options: [
    "Deforestation",
    "Afforestation",
    "Pollution",
    "Urbanization"
  ],
  answer: "Afforestation"
},
{
  question: "A student completes assignments on time without supervision. Which value is demonstrated?",
  options: [
    "Laziness",
    "Responsibility",
    "Carelessness",
    "Irresponsibility"
  ],
  answer: "Responsibility"
},
{
  question: "A society encourages citizens to respect different cultures and beliefs. What is being promoted?",
  options: [
    "Discrimination",
    "Tolerance",
    "Conflict",
    "Division"
  ],
  answer: "Tolerance"
},
{
  question: "A young person acquires skills to start a small business. Which solution to unemployment is being applied?",
  options: [
    "Dependency",
    "Entrepreneurship",
    "Migration",
    "Negligence"
  ],
  answer: "Entrepreneurship"
},
{
  question: "A country improves roads, schools, and healthcare facilities. What does this indicate?",
  options: [
    "Decline",
    "Development",
    "Poverty",
    "Corruption"
  ],
  answer: "Development"
},
{
  question: "A community member reports illegal activities to authorities. Which value is demonstrated?",
  options: [
    "Irresponsibility",
    "Civic duty",
    "Fear",
    "Negligence"
  ],
  answer: "Civic duty"
},
{
  question: "A student avoids bad company and makes independent decisions. Which concept is demonstrated?",
  options: [
    "Peer pressure",
    "Self-control",
    "Irresponsibility",
    "Weakness"
  ],
  answer: "Self-control"
},
{
  question: "A government plans for future generations while meeting present needs. Which concept is being applied?",
  options: [
    "Corruption",
    "Sustainable development",
    "Urbanization",
    "Industrialization"
  ],
  answer: "Sustainable development"
},

{
  question: "A community refuses to follow agreed rules, resulting in frequent conflicts. Which factor is lacking?",
  options: [
    "Freedom",
    "Order",
    "Leadership",
    "Participation"
  ],
  answer: "Order"
},
{
  question: "A leader uses his position to serve the interest of the people rather than himself. Which quality is demonstrated?",
  options: [
    "Selfishness",
    "Accountability",
    "Integrity",
    "Corruption"
  ],
  answer: "Integrity"
},
{
  question: "A town experiences water shortage due to poor management of water resources. Which problem is illustrated?",
  options: [
    "Conservation",
    "Mismanagement",
    "Development",
    "Cooperation"
  ],
  answer: "Mismanagement"
},
{
  question: "A student decides not to join friends in vandalizing school property. Which value is shown?",
  options: [
    "Indiscipline",
    "Self-control",
    "Fear",
    "Weakness"
  ],
  answer: "Self-control"
},
{
  question: "A country experiences peaceful elections where citizens freely choose their leaders. Which system is practiced?",
  options: [
    "Military rule",
    "Dictatorship",
    "Democracy",
    "Monarchy"
  ],
  answer: "Democracy"
},
{
  question: "A community organizes clean-up exercises regularly. What is the main benefit?",
  options: [
    "Pollution",
    "Improved sanitation",
    "Disease spread",
    "Environmental damage"
  ],
  answer: "Improved sanitation"
},
{
  question: "A student always completes tasks without being forced. Which value is demonstrated?",
  options: [
    "Irresponsibility",
    "Responsibility",
    "Carelessness",
    "Negligence"
  ],
  answer: "Responsibility"
},
{
  question: "A government ensures equal distribution of resources among citizens. Which principle is applied?",
  options: [
    "Bias",
    "Equality",
    "Discrimination",
    "Favoritism"
  ],
  answer: "Equality"
},
{
  question: "A farmer practices crop rotation to maintain soil fertility. What concept is demonstrated?",
  options: [
    "Pollution",
    "Sustainability",
    "Deforestation",
    "Urbanization"
  ],
  answer: "Sustainability"
},
{
  question: "A group resolves disagreements through peaceful discussion. Which process is being used?",
  options: [
    "Conflict escalation",
    "Conflict resolution",
    "Competition",
    "Division"
  ],
  answer: "Conflict resolution"
},
{
  question: "A student refuses to take what does not belong to him even when no one is watching. Which value is demonstrated?",
  options: [
    "Dishonesty",
    "Integrity",
    "Fear",
    "Weakness"
  ],
  answer: "Integrity"
},
{
  question: "A society where laws are obeyed and enforced equally is practicing:",
  options: [
    "Corruption",
    "Rule of law",
    "Bias",
    "Favoritism"
  ],
  answer: "Rule of law"
},
{
  question: "A young person learns a trade to earn a living instead of depending on others. What solution is this?",
  options: [
    "Dependency",
    "Entrepreneurship",
    "Negligence",
    "Migration"
  ],
  answer: "Entrepreneurship"
},
{
  question: "A community member participates in decision-making meetings. Which concept is demonstrated?",
  options: [
    "Negligence",
    "Participation",
    "Irresponsibility",
    "Disobedience"
  ],
  answer: "Participation"
},
{
  question: "A country invests in education, healthcare, and infrastructure. What does this indicate?",
  options: [
    "Decline",
    "Development",
    "Corruption",
    "Poverty"
  ],
  answer: "Development"
},
{
  question: "A student respects the opinions of others even when they disagree. Which value is shown?",
  options: [
    "Discrimination",
    "Tolerance",
    "Bias",
    "Conflict"
  ],
  answer: "Tolerance"
},
{
  question: "A community plants more trees to replace those cut down. What is this practice called?",
  options: [
    "Deforestation",
    "Afforestation",
    "Pollution",
    "Industrialization"
  ],
  answer: "Afforestation"
},
{
  question: "A government plans projects that benefit both present and future citizens. Which concept is applied?",
  options: [
    "Corruption",
    "Sustainable development",
    "Urbanization",
    "Industrialization"
  ],
  answer: "Sustainable development"
},
{
  question: "A student refuses to follow negative peer influence. Which concept is demonstrated?",
  options: [
    "Peer pressure",
    "Self-control",
    "Irresponsibility",
    "Weakness"
  ],
  answer: "Self-control"
},
{
  question: "A society ensures that citizens enjoy basic freedoms and rights. What is being promoted?",
  options: [
    "Corruption",
    "Human rights",
    "Discrimination",
    "Bias"
  ],
  answer: "Human rights"
},

{
  question: "A community fails to complete a project because members do not work together. Which factor is responsible?",
  options: [
    "Leadership",
    "Cooperation",
    "Freedom",
    "Discipline"
  ],
  answer: "Cooperation"
},
{
  question: "A leader openly explains how public funds are used. Which principle is demonstrated?",
  options: [
    "Corruption",
    "Transparency",
    "Bias",
    "Negligence"
  ],
  answer: "Transparency"
},
{
  question: "A town experiences flooding due to blocked drainage systems. What is the likely cause?",
  options: [
    "Proper sanitation",
    "Poor waste management",
    "Afforestation",
    "Clean environment"
  ],
  answer: "Poor waste management"
},
{
  question: "A student chooses to study instead of engaging in distractions. Which value is demonstrated?",
  options: [
    "Irresponsibility",
    "Self-discipline",
    "Weakness",
    "Negligence"
  ],
  answer: "Self-discipline"
},
{
  question: "A country allows citizens to freely express their opinions without fear. What principle is being upheld?",
  options: [
    "Corruption",
    "Human rights",
    "Discrimination",
    "Bias"
  ],
  answer: "Human rights"
},
{
  question: "A farmer uses modern techniques to increase crop yield. What does this indicate?",
  options: [
    "Decline",
    "Development",
    "Negligence",
    "Corruption"
  ],
  answer: "Development"
},
{
  question: "A student refuses to take part in bullying others. Which value is demonstrated?",
  options: [
    "Cruelty",
    "Respect",
    "Fear",
    "Weakness"
  ],
  answer: "Respect"
},
{
  question: "A government ensures that resources are used for public benefit. Which concept is demonstrated?",
  options: [
    "Corruption",
    "Accountability",
    "Bias",
    "Negligence"
  ],
  answer: "Accountability"
},
{
  question: "A community organizes tree planting exercises regularly. What is the main goal?",
  options: [
    "Deforestation",
    "Environmental conservation",
    "Pollution",
    "Urbanization"
  ],
  answer: "Environmental conservation"
},
{
  question: "A group settles disagreements by listening to all sides before deciding. Which value is shown?",
  options: [
    "Bias",
    "Fairness",
    "Conflict",
    "Division"
  ],
  answer: "Fairness"
},
{
  question: "A student returns borrowed items without being reminded. Which value is demonstrated?",
  options: [
    "Irresponsibility",
    "Responsibility",
    "Carelessness",
    "Negligence"
  ],
  answer: "Responsibility"
},
{
  question: "A society ensures that no group is treated unfairly. Which principle is applied?",
  options: [
    "Discrimination",
    "Equality",
    "Bias",
    "Favoritism"
  ],
  answer: "Equality"
},
{
  question: "A young person learns a skill to become self-employed. Which concept is demonstrated?",
  options: [
    "Dependency",
    "Entrepreneurship",
    "Negligence",
    "Migration"
  ],
  answer: "Entrepreneurship"
},
{
  question: "A community holds meetings to discuss development issues. Which concept is practiced?",
  options: [
    "Negligence",
    "Participation",
    "Irresponsibility",
    "Disobedience"
  ],
  answer: "Participation"
},
{
  question: "A country improves its healthcare and education systems. What does this show?",
  options: [
    "Decline",
    "Development",
    "Corruption",
    "Poverty"
  ],
  answer: "Development"
},
{
  question: "A student respects school rules even when teachers are not present. Which value is demonstrated?",
  options: [
    "Indiscipline",
    "Integrity",
    "Fear",
    "Weakness"
  ],
  answer: "Integrity"
},
{
  question: "A community encourages peaceful coexistence among different ethnic groups. What is being promoted?",
  options: [
    "Conflict",
    "Unity",
    "Division",
    "Competition"
  ],
  answer: "Unity"
},
{
  question: "A government plans long-term projects for future generations. Which concept is applied?",
  options: [
    "Corruption",
    "Sustainable development",
    "Urbanization",
    "Industrialization"
  ],
  answer: "Sustainable development"
},
{
  question: "A student ignores negative peer influence and focuses on studies. Which value is demonstrated?",
  options: [
    "Peer pressure",
    "Self-control",
    "Irresponsibility",
    "Weakness"
  ],
  answer: "Self-control"
},
{
  question: "A society protects the rights and freedoms of its citizens. What is being practiced?",
  options: [
    "Corruption",
    "Human rights",
    "Discrimination",
    "Bias"
  ],
  answer: "Human rights"
},

{
  question: "A community project delays because members fail to attend meetings regularly. Which factor is lacking?",
  options: [
    "Leadership",
    "Commitment",
    "Freedom",
    "Authority"
  ],
  answer: "Commitment"
},
{
  question: "A leader provides clear information about decisions to the public. Which principle is demonstrated?",
  options: [
    "Secrecy",
    "Transparency",
    "Bias",
    "Corruption"
  ],
  answer: "Transparency"
},
{
  question: "A town experiences frequent disease outbreaks due to poor hygiene practices. What is the likely cause?",
  options: [
    "Proper sanitation",
    "Poor sanitation",
    "Afforestation",
    "Urbanization"
  ],
  answer: "Poor sanitation"
},
{
  question: "A student avoids distractions and focuses on academic goals. Which value is demonstrated?",
  options: [
    "Negligence",
    "Self-discipline",
    "Weakness",
    "Irresponsibility"
  ],
  answer: "Self-discipline"
},
{
  question: "A government protects citizens from discrimination and injustice. Which concept is being upheld?",
  options: [
    "Corruption",
    "Human rights",
    "Bias",
    "Favoritism"
  ],
  answer: "Human rights"
},
{
  question: "A farmer uses irrigation during dry seasons to improve crop production. What does this indicate?",
  options: [
    "Decline",
    "Development",
    "Negligence",
    "Corruption"
  ],
  answer: "Development"
},
{
  question: "A student helps classmates understand difficult topics. Which value is demonstrated?",
  options: [
    "Selfishness",
    "Cooperation",
    "Negligence",
    "Irresponsibility"
  ],
  answer: "Cooperation"
},
{
  question: "A government ensures that leaders are answerable to citizens. Which principle is demonstrated?",
  options: [
    "Corruption",
    "Accountability",
    "Bias",
    "Negligence"
  ],
  answer: "Accountability"
},
{
  question: "A community prevents bush burning to protect vegetation. What is the main aim?",
  options: [
    "Deforestation",
    "Environmental protection",
    "Pollution",
    "Urbanization"
  ],
  answer: "Environmental protection"
},
{
  question: "A group settles disputes by allowing each person to express opinions. Which value is demonstrated?",
  options: [
    "Bias",
    "Fairness",
    "Conflict",
    "Division"
  ],
  answer: "Fairness"
},
{
  question: "A student completes school work without being supervised. Which value is shown?",
  options: [
    "Irresponsibility",
    "Responsibility",
    "Carelessness",
    "Negligence"
  ],
  answer: "Responsibility"
},
{
  question: "A society provides equal access to education for all citizens. Which principle is applied?",
  options: [
    "Discrimination",
    "Equality",
    "Bias",
    "Favoritism"
  ],
  answer: "Equality"
},
{
  question: "A young person starts a small business instead of waiting for employment. Which concept is demonstrated?",
  options: [
    "Dependency",
    "Entrepreneurship",
    "Negligence",
    "Migration"
  ],
  answer: "Entrepreneurship"
},
{
  question: "A community organizes forums to discuss local issues. Which concept is practiced?",
  options: [
    "Negligence",
    "Participation",
    "Irresponsibility",
    "Disobedience"
  ],
  answer: "Participation"
},
{
  question: "A country improves transportation systems and communication networks. What does this indicate?",
  options: [
    "Decline",
    "Development",
    "Corruption",
    "Poverty"
  ],
  answer: "Development"
},
{
  question: "A student avoids taking things that do not belong to him. Which value is demonstrated?",
  options: [
    "Dishonesty",
    "Honesty",
    "Fear",
    "Weakness"
  ],
  answer: "Honesty"
},
{
  question: "A community promotes peaceful coexistence among different religions. What is being encouraged?",
  options: [
    "Conflict",
    "Tolerance",
    "Division",
    "Competition"
  ],
  answer: "Tolerance"
},
{
  question: "A government ensures that natural resources are used wisely for future benefit. Which concept is applied?",
  options: [
    "Corruption",
    "Sustainable development",
    "Urbanization",
    "Industrialization"
  ],
  answer: "Sustainable development"
},
{
  question: "A student resists negative influence from friends and makes independent decisions. Which value is shown?",
  options: [
    "Peer pressure",
    "Self-control",
    "Irresponsibility",
    "Weakness"
  ],
  answer: "Self-control"
},
{
  question: "A society protects freedom of speech and expression. What is being promoted?",
  options: [
    "Corruption",
    "Human rights",
    "Discrimination",
    "Bias"
  ],
  answer: "Human rights"
},

{
  question: "A community project fails because members do not fulfill their assigned roles. Which factor is lacking?",
  options: [
    "Freedom",
    "Responsibility",
    "Leadership",
    "Authority"
  ],
  answer: "Responsibility"
},
{
  question: "A leader ensures that decisions are made openly and information is shared with the public. Which principle is demonstrated?",
  options: [
    "Secrecy",
    "Transparency",
    "Bias",
    "Corruption"
  ],
  answer: "Transparency"
},
{
  question: "A town experiences frequent flooding because drains are filled with waste. What is the main cause?",
  options: [
    "Proper sanitation",
    "Poor waste disposal",
    "Afforestation",
    "Urban planning"
  ],
  answer: "Poor waste disposal"
},
{
  question: "A student avoids distractions and completes assignments on time. Which value is demonstrated?",
  options: [
    "Negligence",
    "Self-discipline",
    "Weakness",
    "Irresponsibility"
  ],
  answer: "Self-discipline"
},
{
  question: "A government enforces laws that protect citizens from unfair treatment. Which concept is upheld?",
  options: [
    "Corruption",
    "Human rights",
    "Bias",
    "Favoritism"
  ],
  answer: "Human rights"
},
{
  question: "A farmer introduces new farming techniques to increase productivity. What does this indicate?",
  options: [
    "Decline",
    "Development",
    "Negligence",
    "Corruption"
  ],
  answer: "Development"
},
{
  question: "A student assists others in group work to achieve a common goal. Which value is demonstrated?",
  options: [
    "Selfishness",
    "Cooperation",
    "Negligence",
    "Irresponsibility"
  ],
  answer: "Cooperation"
},
{
  question: "A government ensures public officials are answerable for their actions. Which principle is demonstrated?",
  options: [
    "Corruption",
    "Accountability",
    "Bias",
    "Negligence"
  ],
  answer: "Accountability"
},
{
  question: "A community stops illegal logging to protect forests. What is the main aim?",
  options: [
    "Deforestation",
    "Environmental conservation",
    "Pollution",
    "Urbanization"
  ],
  answer: "Environmental conservation"
},
{
  question: "A group resolves disagreements by considering each person's opinion equally. Which value is demonstrated?",
  options: [
    "Bias",
    "Fairness",
    "Conflict",
    "Division"
  ],
  answer: "Fairness"
},
{
  question: "A student performs duties without being reminded. Which value is shown?",
  options: [
    "Irresponsibility",
    "Responsibility",
    "Carelessness",
    "Negligence"
  ],
  answer: "Responsibility"
},
{
  question: "A society ensures equal access to employment opportunities. Which principle is applied?",
  options: [
    "Discrimination",
    "Equality",
    "Bias",
    "Favoritism"
  ],
  answer: "Equality"
},
{
  question: "A young person develops a business idea to create jobs. Which concept is demonstrated?",
  options: [
    "Dependency",
    "Entrepreneurship",
    "Negligence",
    "Migration"
  ],
  answer: "Entrepreneurship"
},
{
  question: "A community holds discussions to plan development projects. Which concept is practiced?",
  options: [
    "Negligence",
    "Participation",
    "Irresponsibility",
    "Disobedience"
  ],
  answer: "Participation"
},
{
  question: "A country improves its communication and energy systems. What does this indicate?",
  options: [
    "Decline",
    "Development",
    "Corruption",
    "Poverty"
  ],
  answer: "Development"
},
{
  question: "A student refuses to take items that do not belong to him. Which value is demonstrated?",
  options: [
    "Dishonesty",
    "Honesty",
    "Fear",
    "Weakness"
  ],
  answer: "Honesty"
},
{
  question: "A community promotes harmony among people of different backgrounds. What is being encouraged?",
  options: [
    "Conflict",
    "Unity",
    "Division",
    "Competition"
  ],
  answer: "Unity"
},
{
  question: "A government plans for both present and future needs of its citizens. Which concept is applied?",
  options: [
    "Corruption",
    "Sustainable development",
    "Urbanization",
    "Industrialization"
  ],
  answer: "Sustainable development"
},
{
  question: "A student resists pressure to engage in negative behaviour. Which value is shown?",
  options: [
    "Peer pressure",
    "Self-control",
    "Irresponsibility",
    "Weakness"
  ],
  answer: "Self-control"
},
{
  question: "A society protects citizens' freedom to express ideas and opinions. What is being promoted?",
  options: [
    "Corruption",
    "Human rights",
    "Discrimination",
    "Bias"
  ],
  answer: "Human rights"
},

{
  question: "Which of the following best defines self identity?",
  options: [
    "The physical appearance of a person",
    "The understanding of one�s abilities, traits and personality",
    "The wealth of an individual",
    "The social status of a person"
  ],
  answer: "The understanding of one�s abilities, traits and personality"
},
{
  question: "A student pretends to be from a wealthy family when he is not. This behaviour is known as:",
  options: [
    "Self-confidence",
    "False identity",
    "Honesty",
    "Responsibility"
  ],
  answer: "False identity"
},
{
  question: "According to Maslow�s theory, which need must be satisfied first?",
  options: [
    "Self-esteem",
    "Physiological needs",
    "Social needs",
    "Achievement"
  ],
  answer: "Physiological needs"
},
{
  question: "Which of the following is a way of developing one�s capabilities?",
  options: [
    "Avoiding challenges",
    "Learning new skills",
    "Depending on others always",
    "Ignoring education"
  ],
  answer: "Learning new skills"
},
{
  question: "Adolescence is the period between:",
  options: [
    "0�5 years",
    "6�9 years",
    "10�19 years",
    "20�30 years"
  ],
  answer: "10�19 years"
},
{
  question: "Which of the following best describes reproductive health?",
  options: [
    "Absence of disease only",
    "Complete physical, mental and social well-being related to reproduction",
    "Ability to give birth",
    "Freedom from pregnancy"
  ],
  answer: "Complete physical, mental and social well-being related to reproduction"
},
{
  question: "Which of the following is a consequence of irresponsible adolescent behaviour?",
  options: [
    "Improved health",
    "Teenage pregnancy",
    "Higher education",
    "Economic growth"
  ],
  answer: "Teenage pregnancy"
},
{
  question: "Which of the following is a safety measure for adolescent health?",
  options: [
    "Consulting peers only",
    "Seeking medical advice",
    "Ignoring symptoms",
    "Avoiding hygiene"
  ],
  answer: "Seeking medical advice"
},
{
  question: "Which of the following best explains culture?",
  options: [
    "Only traditional dances",
    "The total way of life of a people",
    "Food only",
    "Language only"
  ],
  answer: "The total way of life of a people"
},
{
  question: "Which cultural practice promotes national unity in Ghana?",
  options: [
    "Conflict",
    "Festivals",
    "Discrimination",
    "Isolation"
  ],
  answer: "Festivals"
},
{
  question: "Which of the following is a negative cultural practice?",
  options: [
    "Festivals",
    "Music and dance",
    "Female genital mutilation",
    "Naming ceremonies"
  ],
  answer: "Female genital mutilation"
},
{
  question: "National identity refers to:",
  options: [
    "Individual beliefs only",
    "Shared values and sense of belonging to a nation",
    "Foreign culture",
    "Temporary practices"
  ],
  answer: "Shared values and sense of belonging to a nation"
},
{
  question: "Which of the following is a national symbol of Ghana?",
  options: [
    "School uniform",
    "National flag",
    "Private car",
    "House"
  ],
  answer: "National flag"
},
{
  question: "Which value promotes peaceful coexistence among citizens?",
  options: [
    "Intolerance",
    "Tolerance",
    "Conflict",
    "Division"
  ],
  answer: "Tolerance"
},
{
  question: "Political independence means:",
  options: [
    "Dependence on other countries",
    "Self-rule and governance",
    "Military rule",
    "Foreign control"
  ],
  answer: "Self-rule and governance"
},
{
  question: "Self-reliance refers to:",
  options: [
    "Depending on foreign aid",
    "Relying on one�s own resources",
    "Avoiding work",
    "Seeking help always"
  ],
  answer: "Relying on one�s own resources"
},
{
  question: "Which of the following is a responsibility of citizens in an independent country?",
  options: [
    "Avoiding work",
    "Contributing to national development",
    "Depending on government only",
    "Ignoring laws"
  ],
  answer: "Contributing to national development"
},
{
  question: "Peace building refers to:",
  options: [
    "Encouraging conflict",
    "Creating harmony in society",
    "Avoiding communication",
    "Promoting violence"
  ],
  answer: "Creating harmony in society"
},
{
  question: "Which of the following is a source of conflict?",
  options: [
    "Justice",
    "Fairness",
    "Greed",
    "Cooperation"
  ],
  answer: "Greed"
},
{
  question: "Which of the following is an effect of conflict?",
  options: [
    "Development",
    "Peace",
    "Destruction of property",
    "Unity"
  ],
  answer: "Destruction of property"
},

{
  question: "Which of the following is an agent of socialization?",
  options: [
    "River",
    "Family",
    "Road",
    "Market"
  ],
  answer: "Family"
},
{
  question: "Which of the following institutions teaches moral values and discipline?",
  options: [
    "Bank",
    "School",
    "Factory",
    "Hospital"
  ],
  answer: "School"
},
{
  question: "Which of the following best explains socialization?",
  options: [
    "Learning how to cook",
    "Process of learning societal norms and values",
    "Playing games only",
    "Working for money"
  ],
  answer: "Process of learning societal norms and values"
},
{
  question: "Which of the following is a physical environmental problem?",
  options: [
    "Unity",
    "Flooding",
    "Respect",
    "Discipline"
  ],
  answer: "Flooding"
},
{
  question: "Which of the following is a way of protecting the physical environment?",
  options: [
    "Indiscriminate dumping",
    "Proper waste disposal",
    "Bush burning",
    "Deforestation"
  ],
  answer: "Proper waste disposal"
},
{
  question: "Which of the following is a cause of environmental degradation?",
  options: [
    "Afforestation",
    "Illegal mining",
    "Recycling",
    "Sanitation"
  ],
  answer: "Illegal mining"
},
{
  question: "Leadership is best defined as:",
  options: [
    "Forcing people to obey",
    "Ability to influence and guide others",
    "Ignoring followers",
    "Avoiding responsibility"
  ],
  answer: "Ability to influence and guide others"
},
{
  question: "Which of the following is a quality of a good leader?",
  options: [
    "Corruption",
    "Honesty",
    "Bias",
    "Selfishness"
  ],
  answer: "Honesty"
},
{
  question: "Which of the following is a function of a constitution?",
  options: [
    "Promotes conflict",
    "Defines structure of government",
    "Encourages corruption",
    "Limits education"
  ],
  answer: "Defines structure of government"
},
{
  question: "Democracy is best described as:",
  options: [
    "Rule by soldiers",
    "Rule by the people",
    "Rule by one person",
    "Foreign rule"
  ],
  answer: "Rule by the people"
},
{
  question: "Which of the following is a feature of democracy?",
  options: [
    "Suppression of rights",
    "Free and fair elections",
    "Military control",
    "No participation"
  ],
  answer: "Free and fair elections"
},
{
  question: "Which of the following promotes peace in society?",
  options: [
    "Violence",
    "Tolerance",
    "Discrimination",
    "Conflict"
  ],
  answer: "Tolerance"
},
{
  question: "Which of the following is a role of the youth in national development?",
  options: [
    "Destroy property",
    "Participate in development activities",
    "Avoid education",
    "Ignore laws"
  ],
  answer: "Participate in development activities"
},
{
  question: "Which of the following is an example of natural resources?",
  options: [
    "Money",
    "Gold",
    "Books",
    "Buildings"
  ],
  answer: "Gold"
},
{
  question: "Which of the following is a renewable resource?",
  options: [
    "Petroleum",
    "Coal",
    "Solar energy",
    "Gold"
  ],
  answer: "Solar energy"
},
{
  question: "Which of the following is a non-renewable resource?",
  options: [
    "Wind",
    "Sunlight",
    "Petroleum",
    "Water"
  ],
  answer: "Petroleum"
},
{
  question: "Which of the following institutions provides financial services?",
  options: [
    "School",
    "Bank",
    "Hospital",
    "Church"
  ],
  answer: "Bank"
},
{
  question: "Which of the following is a way of saving money?",
  options: [
    "Spending all income",
    "Keeping money in a bank",
    "Borrowing unnecessarily",
    "Avoiding planning"
  ],
  answer: "Keeping money in a bank"
},
{
  question: "Which of the following is a cause of unemployment?",
  options: [
    "Skill acquisition",
    "Lack of skills",
    "Education",
    "Development"
  ],
  answer: "Lack of skills"
},
{
  question: "Which of the following is a solution to unemployment?",
  options: [
    "Idleness",
    "Entrepreneurship",
    "Negligence",
    "Dependency"
  ],
  answer: "Entrepreneurship"
},

{
  question: "Which of the following best explains the role of the family in socialization?",
  options: [
    "Providing jobs",
    "Teaching norms and values",
    "Building roads",
    "Providing electricity"
  ],
  answer: "Teaching norms and values"
},
{
  question: "Which of the following is a secondary agent of socialization?",
  options: [
    "Family",
    "School",
    "Parents",
    "Guardians"
  ],
  answer: "School"
},
{
  question: "Which of the following is a problem associated with urbanization?",
  options: [
    "Low population",
    "Overcrowding",
    "Reduced development",
    "Less employment"
  ],
  answer: "Overcrowding"
},
{
  question: "Which of the following is a way of managing the environment?",
  options: [
    "Deforestation",
    "Recycling",
    "Bush burning",
    "Illegal mining"
  ],
  answer: "Recycling"
},
{
  question: "Which of the following is an effect of environmental pollution?",
  options: [
    "Improved health",
    "Disease outbreak",
    "Better sanitation",
    "Clean air"
  ],
  answer: "Disease outbreak"
},
{
  question: "Which of the following best describes followership?",
  options: [
    "Leading others",
    "Supporting and working with leaders",
    "Ignoring leadership",
    "Controlling people"
  ],
  answer: "Supporting and working with leaders"
},
{
  question: "Which of the following is a duty of a citizen?",
  options: [
    "Breaking laws",
    "Paying taxes",
    "Avoiding work",
    "Ignoring rules"
  ],
  answer: "Paying taxes"
},
{
  question: "Which of the following promotes democratic governance?",
  options: [
    "Rigging elections",
    "Free participation",
    "Military control",
    "Suppression of rights"
  ],
  answer: "Free participation"
},
{
  question: "Which of the following is a function of government?",
  options: [
    "Selling goods",
    "Providing security",
    "Farming",
    "Trading"
  ],
  answer: "Providing security"
},
{
  question: "Which of the following is a feature of a good constitution?",
  options: [
    "Promotes dictatorship",
    "Protects citizens� rights",
    "Encourages corruption",
    "Limits freedom"
  ],
  answer: "Protects citizens� rights"
},
{
  question: "Which of the following is a benefit of peace?",
  options: [
    "Destruction",
    "Development",
    "Conflict",
    "Division"
  ],
  answer: "Development"
},
{
  question: "Which of the following is a cause of conflict?",
  options: [
    "Justice",
    "Greed",
    "Tolerance",
    "Unity"
  ],
  answer: "Greed"
},
{
  question: "Which of the following is a responsibility of leaders?",
  options: [
    "Misusing resources",
    "Serving the people",
    "Ignoring citizens",
    "Avoiding decisions"
  ],
  answer: "Serving the people"
},
{
  question: "Which of the following is a role of science and technology in development?",
  options: [
    "Reducing productivity",
    "Improving efficiency",
    "Increasing poverty",
    "Limiting education"
  ],
  answer: "Improving efficiency"
},
{
  question: "Which of the following is an example of appropriate technology?",
  options: [
    "Complex machines only",
    "Tools suitable for local use",
    "Expensive imports",
    "Foreign systems only"
  ],
  answer: "Tools suitable for local use"
},
{
  question: "Which of the following is a benefit of saving money?",
  options: [
    "Financial insecurity",
    "Future security",
    "Increased debt",
    "Wasteful spending"
  ],
  answer: "Future security"
},
{
  question: "Which of the following is a function of financial institutions?",
  options: [
    "Teaching students",
    "Providing loans",
    "Farming",
    "Manufacturing"
  ],
  answer: "Providing loans"
},
{
  question: "Which of the following is a cause of poverty?",
  options: [
    "Employment",
    "Illiteracy",
    "Development",
    "Investment"
  ],
  answer: "Illiteracy"
},
{
  question: "Which of the following is a way to reduce poverty?",
  options: [
    "Unemployment",
    "Skill acquisition",
    "Negligence",
    "Dependency"
  ],
  answer: "Skill acquisition"
},
{
  question: "Which of the following best explains national development?",
  options: [
    "Increase in poverty",
    "Improvement in standard of living",
    "Reduction in education",
    "Decline in economy"
  ],
  answer: "Improvement in standard of living"
},

{
  question: "Which of the following is a primary agent of socialization?",
  options: [
    "Media",
    "Family",
    "Government",
    "Church"
  ],
  answer: "Family"
},
{
  question: "Which of the following is a secondary agent of socialization?",
  options: [
    "Parents",
    "Siblings",
    "School",
    "Guardians"
  ],
  answer: "School"
},
{
  question: "Which of the following is an example of peer group influence?",
  options: [
    "Advice from parents",
    "Pressure from friends of the same age",
    "Government policies",
    "School rules"
  ],
  answer: "Pressure from friends of the same age"
},
{
  question: "Which level of Maslow�s hierarchy includes love and belonging?",
  options: [
    "Physiological needs",
    "Safety needs",
    "Social needs",
    "Self-actualization"
  ],
  answer: "Social needs"
},
{
  question: "Which level of Maslow�s hierarchy represents achieving one's full potential?",
  options: [
    "Safety needs",
    "Esteem needs",
    "Self-actualization",
    "Physiological needs"
  ],
  answer: "Self-actualization"
},
{
  question: "Which of the following is a type of leadership?",
  options: [
    "Democratic leadership",
    "Financial leadership",
    "Cultural leadership",
    "Social leadership"
  ],
  answer: "Democratic leadership"
},
{
  question: "Which leadership style involves taking decisions without consulting others?",
  options: [
    "Democratic",
    "Autocratic",
    "Participatory",
    "Consultative"
  ],
  answer: "Autocratic"
},
{
  question: "Which organ of government is responsible for making laws?",
  options: [
    "Executive",
    "Judiciary",
    "Legislature",
    "Military"
  ],
  answer: "Legislature"
},
{
  question: "Which organ of government interprets laws?",
  options: [
    "Executive",
    "Judiciary",
    "Legislature",
    "Police"
  ],
  answer: "Judiciary"
},
{
  question: "Which organ of government implements laws?",
  options: [
    "Judiciary",
    "Legislature",
    "Executive",
    "Court"
  ],
  answer: "Executive"
},
{
  question: "Which of the following is an example of a natural resource?",
  options: [
    "Machines",
    "Gold",
    "Buildings",
    "Roads"
  ],
  answer: "Gold"
},
{
  question: "Which of the following is a human resource?",
  options: [
    "Land",
    "Labour",
    "Water",
    "Minerals"
  ],
  answer: "Labour"
},
{
  question: "Which of the following is a capital resource?",
  options: [
    "River",
    "Forest",
    "Machines",
    "Soil"
  ],
  answer: "Machines"
},
{
  question: "Which of the following best explains appropriate technology?",
  options: [
    "Highly expensive machines",
    "Technology suited to local needs",
    "Foreign equipment only",
    "Complex systems only"
  ],
  answer: "Technology suited to local needs"
},
{
  question: "Which of the following is a benefit of science and technology?",
  options: [
    "Reduced productivity",
    "Improved communication",
    "Increased poverty",
    "Limited knowledge"
  ],
  answer: "Improved communication"
},
{
  question: "Which of the following is a negative effect of technology?",
  options: [
    "Improved efficiency",
    "Job losses",
    "Better communication",
    "Faster production"
  ],
  answer: "Job losses"
},
{
  question: "Which of the following best explains population growth?",
  options: [
    "Decrease in population",
    "Increase in number of people",
    "Migration only",
    "Death rate only"
  ],
  answer: "Increase in number of people"
},
{
  question: "Which of the following is a cause of high population growth?",
  options: [
    "Low birth rate",
    "High birth rate",
    "High death rate",
    "Migration out"
  ],
  answer: "High birth rate"
},
{
  question: "Which of the following is an effect of overpopulation?",
  options: [
    "Abundant resources",
    "Pressure on resources",
    "Improved living conditions",
    "Less unemployment"
  ],
  answer: "Pressure on resources"
},
{
  question: "Which of the following is a way to control population growth?",
  options: [
    "Encouraging early marriage",
    "Family planning",
    "Ignoring education",
    "Increasing birth rate"
  ],
  answer: "Family planning"
},
  {
    question: "What can students do to contribute to solving environmental problems in their schools?",
    options: [
      "Wait for teachers to act",
      "Litter the compound",
      "Organize clean-up campaigns and educate peers",
      "Complain daily"
    ],
    answer: "Organize clean-up campaigns and educate peers"
  }
];
export default jhssocialStudiesQuestions;